import React from 'react';
import { BlueLense } from '../presentation/BlueLense';
import { CallToAction } from '../presentation/CallToAction';
import { EyeGlassesSlider } from '../presentation/EyeGlassesSlider';
import { Footer } from '../presentation/Footer';
import { GlassesCategory } from '../presentation/GlassesCategory';
import { Header } from "../presentation/Header";
import { HomeBanner } from '../presentation/HomeBanner';
import { NewArrivals } from '../presentation/NewArrivals';
import { Offer } from '../presentation/Offer';
import { OurBrands } from '../presentation/OurBrands';
import { SightcartTribe } from '../presentation/SightcartTribe';
import { SunnGlassesSlider } from '../presentation/SunnGlassesSlider';
import { TrendingNow } from '../presentation/TrendingNow';

const Home = () => {
    return (
        <>
            <Header />
            <GlassesCategory />
            <HomeBanner />
            <NewArrivals />
            <Offer />
            <TrendingNow />
            <OurBrands />
            <EyeGlassesSlider />
            <SunnGlassesSlider />
            <Offer />
            <EyeGlassesSlider />
            <SunnGlassesSlider />
            <OurBrands />
            <EyeGlassesSlider />
            <SunnGlassesSlider />
            <Offer />
            <BlueLense />
            <CallToAction />
            <SightcartTribe />
            <Footer />
        </>
    )
}
 export default Home;